const BottomBar = () => {
    return (
        <div className="bottomBar-container">
            <div className="bottomBar-content from-bottom">
                <div className="bottomBar-left from-left">
                    <span className="bottomBar-text1">INDÚSTRIA CAPACITADA</span>
                    <span className="bottomBar-text2">PARA TODO O MERCADO CONSUMIDOR</span>
                </div>
                <div className="bottomBar-right from-right">
                    <span className="bottomBar-text1">PRODUTOS HOMOLOGADOS</span>
                    <span className="bottomBar-text2">EM TODOS OS PAÍSES DO MERCOSUL</span>
                </div>
            </div>
        </div>
    )
}
export default BottomBar;